(() => {
  'use strict';
  const config = window.dailyArchive || {};
  const root = config.root || '/';
  const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const money = cents => {
    const currency = config.currency || 'JPY';
    // Shopify Ajax amounts always use hundredths, including zero-decimal currencies.
    return new Intl.NumberFormat('en-US', {style:'currency', currency, currencyDisplay:'code'}).format(Number(cents) / 100);
  };
  const icon = name => {
    const paths = {minus:'<path d="M5 12h14"/>',plus:'<path d="M5 12h14M12 5v14"/>',arrow:'<path d="M4 12h15m-6-6 6 6-6 6"/>',bag:'<path d="M5 7h14l1 14H4L5 7Z"/><path d="M8 8V6a4 4 0 0 1 8 0v2"/>'};
    return `<svg class="icon" aria-hidden="true" viewBox="0 0 24 24">${paths[name] || ''}</svg>`;
  };
  let returnFocus = null;
  let toastTimer;
  let searchTimer;
  let searchAbort;
  let cartPromise = null;
  const toast = message => {
    const el = document.getElementById('toast');
    if (!el) return;
    el.textContent = message; el.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('show'), 2800);
  };
  const closeOverlay = (restore = true) => {
    document.querySelectorAll('.overlay.open').forEach(el => {el.classList.remove('open');el.setAttribute('aria-hidden','true');});
    document.body.classList.remove('locked');
    document.querySelectorAll('body > .shopify-section, #main').forEach(el => {el.inert = false;});
    if (restore && returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
  };
  const openOverlay = id => {
    closeOverlay(false);
    returnFocus = document.activeElement;
    const overlay = document.getElementById(id);
    if (!overlay) return;
    overlay.classList.add('open'); overlay.setAttribute('aria-hidden','false');
    document.body.classList.add('locked');
    document.querySelectorAll('body > .shopify-section, #main').forEach(el => {el.inert = true;});
    (id === 'search-overlay' ? overlay.querySelector('input[type="search"]') : overlay.querySelector('[data-close]'))?.focus({preventScroll:true});
  };
  const cartItem = item => {
    const options = (item.options_with_values || []).filter(option => option.value !== 'Default Title').map(option => option.value).join(' / ');
    return `<article class="cart-item"><a href="${esc(item.url)}">${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.product_title)}" width="100" height="110">` : ''}</a><div class="cart-item-info"><h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3><p>${esc(options)}</p><div class="quantity-picker"><button type="button" data-cart-qty="-1" data-key="${esc(item.key)}" aria-label="Decrease quantity for ${esc(item.product_title)}" ${item.quantity <= 1 ? 'disabled' : ''}>${icon('minus')}</button><output aria-label="Quantity for ${esc(item.product_title)}">${item.quantity}</output><button type="button" data-cart-qty="1" data-key="${esc(item.key)}" aria-label="Increase quantity for ${esc(item.product_title)}" ${item.quantity >= 99 ? 'disabled' : ''}>${icon('plus')}</button></div></div><div class="item-end"><span>${money(item.final_line_price)}</span><button class="remove-item" type="button" data-remove="${esc(item.key)}" aria-label="Remove ${esc(item.product_title)}">Remove</button></div></article>`;
  };
  let currentCart = null;
  const renderCart = cart => {
    currentCart = cart;
    const retailCart = cart.items.length > 0 && cart.items.every(item => String(item.sku || '').startsWith('DA-BAG-'));
    const previewCart = config.demoMode && !retailCart;
    document.querySelectorAll('.cart-count').forEach(el => {el.textContent = cart.item_count;el.classList.toggle('is-empty',cart.item_count === 0);});
    const items = document.getElementById('drawer-items');
    const footer = document.getElementById('drawer-footer');
    if (!items || !footer) return;
    items.innerHTML = cart.items.length ? cart.items.map(cartItem).join('') : `<div class="empty-state">${icon('bag')}<h2>Your cart is empty</h2><p>Explore the collection to get started.</p><a class="button" href="${esc(root)}collections/bags">Continue shopping</a></div>`;
    footer.innerHTML = cart.items.length ? `<div class="summary-row"><span>Subtotal · ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}</span><strong>${money(cart.total_price)}</strong></div><a class="button" href="${esc(config.cart || root+'cart')}">View cart ${icon('arrow')}</a>${previewCart ? `<button class="button outline" type="button" data-close>Continue shopping</button><p class="detail-note">Store preview. Checkout is not available in this demo.</p>` : `<form action="${esc(config.cart || root+'cart')}?locale=en" method="post"><input type="hidden" name="locale" value="en"><button class="button outline" type="submit" name="checkout">Checkout</button></form><p class="detail-note">Taxes and shipping calculated at checkout.</p>`}` : '';
    if (cart.currency) config.currency = cart.currency;
  };
  const fetchCart = () => {
    if (cartPromise) return cartPromise;
    cartPromise = fetch(`${config.cart || root+'cart'}.js`, {credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(response => {if (!response.ok) throw new Error('Your cart could not be loaded. Please try again.');return response.json();})
      .then(cart => {renderCart(cart);return cart;})
      .finally(() => {cartPromise = null;});
    return cartPromise;
  };
  const showCartError = message => {
    toast(message);
    const items = document.getElementById('drawer-items');
    if (items && !currentCart) items.innerHTML = `<div class="empty-state"><p>${esc(message)}</p><a class="button" href="${esc(config.cart || root+'cart')}">View cart</a></div>`;
  };
  const openCart = () => {
    openOverlay('cart-overlay');
    fetchCart().catch(error => showCartError(error.message));
  };
  const changeCart = async (key, quantity, button) => {
    const items = document.getElementById('drawer-items');
    items?.setAttribute('aria-busy','true');
    try {
      const response = await fetch(`${config.cartChange || root+'cart/change'}.js`, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Your cart could not be updated.');
      renderCart(data);
      const target = button?.dataset.remove ? document.querySelector('#cart-overlay [data-close]') : [...document.querySelectorAll('#drawer-items [data-key]')].find(el => el.dataset.key === key && el.dataset.cartQty === button?.dataset.cartQty && !el.disabled);
      target?.focus({preventScroll:true});
    } catch (error) {showCartError(error.message);} finally {items?.removeAttribute('aria-busy');}
  };
  const searchProducts = async query => {
    const results = document.getElementById('search-results');
    if (!results) return;
    searchAbort?.abort();
    if (!query.trim()) {results.innerHTML = '';return;}
    searchAbort = new AbortController();
    results.setAttribute('aria-busy','true');
    try {
      let predictiveEnabled = true;
      try {predictiveEnabled = JSON.parse(document.getElementById('shopify-features')?.textContent || '{}').predictiveSearch !== false;} catch {}
      const requestResults = predictive => {
        const params = new URLSearchParams(predictive
          ? {q:query,'resources[type]':'product','resources[limit]':'6','resources[options][unavailable_products]':'last',section_id:'bags-predictive-search'}
          : {q:query,type:'product','options[prefix]':'last',section_id:'bags-predictive-search'});
        const endpoint = predictive ? (config.predictiveSearch || root+'search/suggest') : (config.search || root+'search');
        return fetch(`${endpoint}?${params}`,{signal:searchAbort.signal,headers:{Accept:'text/html'}});
      };
      let response = await requestResults(predictiveEnabled);
      if (predictiveEnabled && response.status === 417) response = await requestResults(false);
      if (!response.ok) throw new Error('Search is unavailable.');
      const markup = await response.text();
      const rendered = new DOMParser().parseFromString(markup,'text/html').querySelector('[data-bags-predictive-results]');
      if (!rendered) throw new Error('Search is unavailable.');
      results.innerHTML = rendered.innerHTML;
    } catch (error) {if (error.name !== 'AbortError') results.innerHTML = `<p class="search-help">Press Enter to see all search results.</p>`;} finally {results.removeAttribute('aria-busy');}
  };
  document.addEventListener('submit',async event => {
    const form = event.target.closest('[data-daily-product-form]');
    if (!form) return;
    event.preventDefault();
    if (event.submitter?.hasAttribute('data-direct-checkout')) {
      const data = new FormData(form);
      const id = String(data.get('id') || '');
      const quantity = Number(data.get('quantity') || 1);
      if (!/^\d+$/.test(id) || !Number.isInteger(quantity) || quantity < 1 || quantity > 99) {
        const error = form.querySelector('.form-error');
        if (error) {error.textContent = 'Choose a product option and a valid quantity.';error.hidden = false;}
        return;
      }
      const checkoutUrl = new URL(`${root}cart/${id}:${quantity}`, window.location.origin);
      checkoutUrl.searchParams.set('locale', 'en');
      window.location.assign(checkoutUrl.href);
      return;
    }
    const button = form.querySelector('[type="submit"]');
    const errorBox = form.querySelector('.form-error');
    const original = button.textContent;
    button.disabled = true; button.textContent = 'Adding…';
    if (errorBox) {errorBox.hidden = true;errorBox.textContent = '';}
    try {
      const response = await fetch(`${config.cartAdd || root+'cart/add'}.js`, {method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(form)});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added. Please try again.');
      await fetchCart(); openOverlay('cart-overlay');
      document.dispatchEvent(new CustomEvent('daily:cart-updated',{detail:currentCart}));
    } catch (error) {
      if (errorBox) {errorBox.textContent = error.message;errorBox.hidden = false;}
      toast(error.message);
    } finally {button.disabled = false;button.textContent = original;}
  });
  document.addEventListener('click',event => {
    const previewCheckout = event.target.closest('[data-demo-checkout]');
    if (previewCheckout && config.demoMode) {event.preventDefault();const summary = document.getElementById('checkout-summary');if (summary && currentCart) summary.textContent = `Your cart contains ${currentCart.item_count} ${currentCart.item_count === 1 ? 'item' : 'items'}. Preview subtotal: ${money(currentCart.total_price)}.`;openOverlay('checkout-overlay');return;}
    const openCartLink = event.target.closest('[data-open-cart]');
    if (openCartLink) {event.preventDefault();openCart();return;}
    const openSearchLink = event.target.closest('[data-open-search]');
    if (openSearchLink) {event.preventDefault();openOverlay('search-overlay');return;}
    if (event.target.classList.contains('overlay') || event.target.closest('[data-close]')) {closeOverlay();return;}
    const toggle = event.target.closest('.mobile-toggle');
    if (toggle) {const nav = document.getElementById('main-nav');const open = nav.classList.toggle('open');toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open ? 'Close menu' : 'Open menu');return;}
    const gallery = event.target.closest('[data-gallery]');
    if (gallery) {const image = document.getElementById('detail-image');if (image) {image.removeAttribute('srcset');image.src = gallery.dataset.gallery;image.alt = gallery.dataset.galleryAlt || '';document.querySelectorAll('[data-gallery]').forEach(el => {el.classList.toggle('active',el === gallery);el.setAttribute('aria-pressed',String(el === gallery));});}return;}
    const productQty = event.target.closest('[data-product-qty]');
    if (productQty) {const input = productQty.closest('.quantity-picker').querySelector('input');input.value = Math.max(1,Math.min(99,Number(input.value || 1)+Number(productQty.dataset.productQty)));input.dispatchEvent(new Event('change',{bubbles:true}));return;}
    const cartQty = event.target.closest('[data-cart-qty]');
    if (cartQty && currentCart) {const item = currentCart.items.find(item => item.key === cartQty.dataset.key);if (item) changeCart(item.key,Math.max(1,Math.min(99,item.quantity+Number(cartQty.dataset.cartQty))),cartQty);return;}
    const remove = event.target.closest('[data-remove]');
    if (remove) {changeCart(remove.dataset.remove,0,remove);return;}
    const pageQty = event.target.closest('[data-cart-page-qty]');
    if (pageQty) {const input = pageQty.closest('.quantity-picker').querySelector('input');input.value = Math.max(0,Math.min(99,Number(input.value || 0)+Number(pageQty.dataset.cartPageQty)));return;}
  });
  document.addEventListener('change',event => {
    if (event.target.matches('.daily-sort-form select')) {event.target.form.submit();return;}
    if (event.target.matches('.daily-variant-picker input[name="id"]')) {
      const form = event.target.form;
      form.querySelectorAll('.size-option').forEach(el => el.classList.toggle('selected',el.contains(event.target)));
      const button = form.querySelector('[type="submit"]');
      const available = event.target.dataset.available === 'true';
      button.disabled = !available;button.textContent = available ? 'Add to cart' : 'Sold out';
      const price = document.getElementById('DailyProductPrice');
      if (price) price.textContent = event.target.dataset.price;
      const url = new URL(window.location.href);url.searchParams.set('variant',event.target.value);history.replaceState(null,'',url);
    }
    if (event.target.matches('#DailyQuantity')) {const input = event.target;input.value = Math.max(1,Math.min(99,Number(input.value || 1)));const picker = input.closest('.quantity-picker');picker.querySelector('[data-product-qty="-1"]').disabled = Number(input.value) <= 1;picker.querySelector('[data-product-qty="1"]').disabled = Number(input.value) >= 99;}
  });
  document.addEventListener('input',event => {if (event.target.id === 'global-search') {clearTimeout(searchTimer);searchTimer = setTimeout(() => searchProducts(event.target.value),200);}});
  document.addEventListener('keydown',event => {
    if (event.key === 'Escape') {closeOverlay();const nav = document.getElementById('main-nav');nav?.classList.remove('open');const toggle = document.querySelector('.mobile-toggle');toggle?.setAttribute('aria-expanded','false');toggle?.setAttribute('aria-label','Open menu');}
    if (event.key !== 'Tab') return;
    const overlay = document.querySelector('.overlay.open');
    if (!overlay) return;
    const controls = [...overlay.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]),select,[tabindex="0"]')].filter(el => el.getClientRects().length);
    const first = controls[0],last = controls.at(-1);
    if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
    else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
  });
  document.addEventListener('shopify:section:load',() => {document.querySelector('.overlay.open') && closeOverlay(false);});
})();
